import { render } from "./BlockApp.vue?vue&type=template&id=58b47104"
import script from "./BlockApp.vue?vue&type=script&lang=js"
export * from "./BlockApp.vue?vue&type=script&lang=js"

import "./BlockApp.vue?vue&type=style&index=0&id=58b47104&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__